import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios';
import BaseUrl from '../../../assets/utils/accessToken'

export const addNewTicket = createAsyncThunk('ticket/addNewTicket',
  async (data, { rejectWithValue }) => {
    try {
      const tokenStored = localStorage.getItem('TokenStored')
      const timezone    = localStorage.getItem('TZ')
      return await axios.post(BaseUrl + '/v2/ajouterTicket', data,
        { headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenStored, 'Platform': 'web', 'timezone': timezone } })
    } catch (error) { return rejectWithValue(error.response.status) }
  }
);

export const fetchFilteredTickets = createAsyncThunk('ticket/fetchFilteredTickets', async (data) => {
  const { paginationModel, body } = data || {};
  const { page = 1, pageSize = 12 } = paginationModel || {};
  const requestBody = body ?? { values: {} };
  const tokenStored = localStorage.getItem('TokenStored');
  const timezone    = localStorage.getItem('TZ');
  try {
    const response = await axios.post(`${BaseUrl}/v2/getListTicketsFiltres?page=${page}&pageSize=${pageSize}`, requestBody,
      { headers: { 'Content-Type': 'application/json', 'Authorization': tokenStored, 'Platform': 'web', 'timezone': timezone } });
    return response.data;
  } catch (error) { throw error.response?.data || error.message; }
});

export const fetchTickets = createAsyncThunk('ticket/fetchTickets', (paginationModel) => {
  const tokenStored = localStorage.getItem('TokenStored')
  const timezone    = localStorage.getItem('TZ')
  return axios.get(BaseUrl + `/v2/getListTickets?page=${paginationModel.page}&pageSize=${paginationModel.pageSize}`,
    { headers: { 'Content-Type': 'application/json', 'Authorization': tokenStored, 'Platform': 'web', 'timezone': timezone } }
  ).then(res => res.data);
});

export const fetchTicketById = createAsyncThunk('ticket/fetchTicketById', (id) => {
  const tokenStored = localStorage.getItem('TokenStored')
  const timezone    = localStorage.getItem('TZ')
  return axios.get(BaseUrl + `/v2/getTicketParId?id=${id}`,
    { headers: { 'Content-Type': 'application/json', 'Authorization': tokenStored, 'Platform': 'web', 'timezone': timezone } }
  ).then(res => res.data.data.result);
});

export const updateTicketState = createAsyncThunk('ticket/updateTicketState', (data) => {
  const tokenStored = localStorage.getItem('TokenStored')
  const timezone    = localStorage.getItem('TZ')
  return axios.put(BaseUrl + `/SAV/updateStatutTicket/v3`, data,
    { headers: { 'Content-Type': 'application/json', 'Authorization': tokenStored, 'Platform': 'web', 'timezone': timezone } });
});

export const executeTicket = createAsyncThunk('ticket/executeTicket', (data) => {
  const tokenStored = localStorage.getItem('TokenStored')
  const timezone    = localStorage.getItem('TZ')
  return axios.put(BaseUrl + `/v2/executerTicket?id=${data.id}&connectionId=${data.connectionId}`, data,
    { headers: { 'Content-Type': 'application/json', 'Authorization': tokenStored, 'Platform': 'web', 'timezone': timezone } });
});

export const updateTicketAssignedTo = createAsyncThunk('ticket/updateTicketAssignedTo', (data) => {
  const tokenStored = localStorage.getItem('TokenStored')
  const timezone    = localStorage.getItem('TZ')
  return axios.put(BaseUrl + `/v2/updateAssignementTicket?idTicket=${data.openTicket}&assigneeId=${data.assigneeId}`, data,
    { headers: { 'Content-Type': 'application/json', 'Authorization': tokenStored, 'Platform': 'web', 'timezone': timezone } });
});

export const updateTicket = createAsyncThunk('ticket/updateTicket', (data) => {
  const tokenStored = localStorage.getItem('TokenStored')
  const timezone    = localStorage.getItem('TZ')
  return axios.put(BaseUrl + `/v2/updateTicket?id=${data.id}`, data.modified,
    { headers: { 'Content-Type': 'application/json', 'Authorization': tokenStored, 'Platform': 'web', 'timezone': timezone } });
});

// ─────────────────────────────────────────────────────────────────
// ESCALADE — type: 0 = Paramétrage | 1 = IT | 2 = Développement
// ─────────────────────────────────────────────────────────────────

/** POST /SAV/InternalAddStatutTicket
 *  Body: { ticketId, type, description, numTicketDev? } */
export const internalAddStatutTicket = createAsyncThunk('ticket/internalAddStatutTicket',
  async (data, { rejectWithValue }) => {
    try {
      const tokenStored = localStorage.getItem('TokenStored')
      const timezone    = localStorage.getItem('TZ')
      const response    = await axios.post(BaseUrl + '/SAV/InternalAddStatutTicket', data,
        { headers: { 'Content-Type': 'application/json', 'Authorization': tokenStored, 'Platform': 'web', 'timezone': timezone } })
      return response.data
    } catch (error) { return rejectWithValue(error.response?.data || error.message) }
  }
);

/** PUT /SAV/InternalUpdateStatutTicket
 *  Continuer : { id, ticketId, type, description }
 *  Clôturer  : { id, ticketId, description }  ← sans type */
export const internalUpdateStatutTicket = createAsyncThunk('ticket/internalUpdateStatutTicket',
  async (data, { rejectWithValue }) => {
    try {
      const tokenStored = localStorage.getItem('TokenStored')
      const timezone    = localStorage.getItem('TZ')
      const response    = await axios.put(BaseUrl + '/SAV/InternalUpdateStatutTicket', data,
        { headers: { 'Content-Type': 'application/json', 'Authorization': tokenStored, 'Platform': 'web', 'timezone': timezone } })
      return response.data
    } catch (error) { return rejectWithValue(error.response?.data || error.message) }
  }
);

// ─────────────────────────────────────────────────────────────────

const initialState = { loading: false, data: [], tickets: [], filtredTickets: [], ticket: null, error: "" };

const ticketsSlice = createSlice({
  name: ' ticket',
  initialState,
  extraReducers: (builder) => {
    const handle = (thunk, onFulfilled) => {
      builder.addCase(thunk.pending,   (state)          => { state.loading = true; })
      builder.addCase(thunk.fulfilled, (state, action)  => { state.loading = false; state.error = ""; if (onFulfilled) onFulfilled(state, action); })
      builder.addCase(thunk.rejected,  (state, action)  => { state.loading = false; state.error = action.error.message; })
    };

    handle(addNewTicket,              (s, a) => { s.data = a.payload; });
    handle(fetchTickets,              (s, a) => { s.tickets = a.payload.data; });
    handle(fetchTicketById,           (s, a) => { s.ticket = a.payload; });
    handle(fetchFilteredTickets,      (s, a) => { s.filtredTickets = a.payload.data; });
    handle(updateTicketAssignedTo);
    handle(executeTicket);
    handle(internalAddStatutTicket);
    handle(internalUpdateStatutTicket);

    builder.addCase('api_error', (state, action) => {
      state.error = action?.payload?.response?.data?.failureResponse?.codeFI?.code === 808
        ? '' : action?.payload?.message;
    });
  }
});

export default ticketsSlice.reducer;